import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import CallToAction from '../components/CallToAction';
import './About.css';

import academyLogo from '../assets/images/ProgenX Akademi.png';
import hakkindaHeroImage from '../assets/images/hakkinda.jpg';
import kalkinma from '../assets/images/kalkinma.png';
import aws from '../assets/images/aws.png';
import timteb from '../assets/images/timteb.jpg';
import googleforstartups from '../assets/images/googleforstartups.png';
import microsoftforstartups from '../assets/images/microsoftforstartups.png';
import nvidiaInception from '../assets/images/nvidia-inception-logo.png';
import etkimlogodct from '../assets/images/etkimlogodct.png';

const About = () => {
  return (
    <div className="about">
      <Helmet>
        <title>ProgenX Hakkında | Yazılım ve Bilişim Teknolojileri Şirketi 2026</title>
        <meta name="description" content="ProgenX, TÜBİTAK BİGG fonu ile kurulmuş, yazılım geliştirme, yapay zeka, IoT ve akıllı raporlama çözümleri sunan yenilikçi bir teknoloji şirketidir. ODTÜ Teknokent'te faaliyet gösteren, AWS Activate üyesi ve Teknogirişim Rozeti sahibi şirketimizin vizyonu, misyonu ve hizmetleri hakkında bilgi edinin." />
        <meta name="keywords" content="progenx hakkında, progenx vizyonu, progenx misyonu, yazılım şirketi, yapay zeka, IoT, tübitak bigg, odtü teknokent, aws activate, teknogirişim rozeti, etkim meb" />
        <meta property="og:title" content="ProgenX Hakkında | Yazılım ve Bilişim Teknolojileri" />
        <meta property="og:description" content="TÜBİTAK BİGG fonu ile kurulmuş, yazılım ve dijital dönüşüm çözümleri sunan teknoloji şirketi." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenx.com.tr/hakkinda" />
        <link rel="canonical" href="https://progenx.com.tr/hakkinda" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "ProgenX Eğitim ve Bilişim Teknolojileri A.Ş.",
            "url": "https://progenx.com.tr",
            "logo": "https://progenx.com.tr/logo.png",
            "description": "Yazılım geliştirme, yapay zeka, IoT ve akıllı raporlama çözümleri sunan teknoloji şirketi",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Üniversiteler Mah. İhsan Doğramacı Bul. No: 31 İç Kapı No: 20",
              "addressLocality": "Çankaya",
              "addressRegion": "Ankara",
              "postalCode": "06800",
              "addressCountry": "TR"
            },
            "foundingDate": "2020",
            "award": "Teknogirişim Rozeti",
            "memberOf": ["AWS Activate", "ETKİM MEB", "TÜBİTAK BİGG"]
          })}
        </script>
      </Helmet>
      
      <Hero 
        title="Hakkımızda" 
        backgroundImage={hakkindaHeroImage}
      />
      
      <section className="about-content">
        <div className="container">
          <div className="about-row">
            <div className="about-text">
              <h2 className="section-title">PROGENX</h2>
              <div className="about-description">
                <p>
                  ProgenX, yazılım geliştirme, yapay zeka, IoT ve akıllı raporlama alanlarında yenilikçi çözümler sunan bir teknoloji şirketidir. 
                  Türkiye Eğitim Teknolojileri Zirvesi'nde (TETZ) yer almış, ETKİM MEB bünyesinde faaliyet gösteren, AWS Activate üyesi olan ve 
                  T.C. Sanayi ve Teknoloji Bakanlığı tarafından verilen Teknogirişim Rozeti'ni almaya hak kazanan şirketimiz, 
                  eğitimden endüstriye geniş bir yelpazede dijital dönüşüm çözümleri sunmaktadır.
                </p>

                <p>
                  ProgenX olarak, eğitim teknolojilerinden kurumsal yazılım projelerine, veri bilimi çözümlerinden IoT entegrasyonlarına kadar geniş bir hizmet yelpazesi sunuyoruz. Her projeye özgü, ölçeklenebilir ve güvenilir çözümler üreterek müşterilerimizin dijital dönüşüm süreçlerinde güvenilir bir iş ortağı olmayı hedefliyoruz.
                </p>
                <p>
                  TÜBİTAK BİGG fonu ile kurulmuş bir şirket olan ProgenX, yalnızca eğitim teknolojileriyle sınırlı kalmıyor; aynı zamanda bilişim ve dijital dönüşüm alanında da geniş bir hizmet yelpazesi sunuyor. Veri bilimi ve yapay zeka çözümlerimiz ile büyük veri setlerinden anlamlı bilgiler çıkarıyor, işletmelerin karar alma süreçlerine güç katıyoruz. Mobil ve web uygulama geliştirme hizmetlerimizle kullanıcı dostu, yüksek performanslı dijital ürünler yaratıyor ve iş süreçlerini dijitalleştiriyoruz.
                </p>
                
                <h3>Vizyonumuz</h3>
                <p>
                  Yazılım ve teknoloji alanında dünya çapında yenilikçi çözümler üreterek, bireylerin ve işletmelerin potansiyellerini en üst düzeye çıkaran bir lider olmayı hedefliyoruz. Teknolojiyi, herkesin ulaşabileceği şekilde geliştirerek, toplumda sürdürülebilir dijital dönüşüm süreçlerini hayata geçirmeyi amaçlıyoruz.
                </p>
                
                <h3>Misyonumuz</h3>
                <p>
                  ProgenX olarak, yazılım geliştirme, yapay zeka, IoT ve akıllı raporlama alanlarında müşterilerimize en yüksek kalitede çözümler sunarak dijital dönüşüm süreçlerinde güvenilir bir iş ortağı olmayı hedefliyoruz. Bilişim, yazılım ve dijital dönüşüm çözümleriyle işletmelerin verimliliklerini artırırken, teknolojiye dayalı inovatif projelerle sektördeki en yüksek standartları belirliyoruz.
                </p>

                <div className="about-logos-section">
                  <h4 className="about-logos-heading">Destekleyen</h4>
                  <div className="about-logos-grid about-logos-backed">
                    <div className="about-logo-item">
                      <img src={kalkinma} alt="Türkiye Kalkınma Fonu" />
                    </div>
                  </div>
                  <h4 className="about-logos-heading">Üye Olduğumuz Programlar</h4>
                  <div className="about-logos-grid about-logos-member">
                    <div className="about-logo-item">
                      <img src={aws} alt="AWS" />
                    </div>
                    <div className="about-logo-item">
                      <img src={timteb} alt="TİMTEB" />
                    </div>
                    <div className="about-logo-item">
                      <img src={googleforstartups} alt="Google for Startups" />
                    </div>
                    <div className="about-logo-item">
                      <img src={microsoftforstartups} alt="Microsoft for Startups" />
                    </div>
                    <div className="about-logo-item">
                      <img src={nvidiaInception} alt="NVIDIA Inception" />
                    </div>
                    <div className="about-logo-item">
                      <img src={etkimlogodct} alt="ETKİM" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="about-image">
              <img src={academyLogo} alt="ProgenX Logo" />
              <div className="about-quote">
                <p>"Geleceği tahmin etmenin en iyi yolu onu oluşturmaktır."</p>
                <p className="quote-author">-Peter Drucker & Abraham Lincoln</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <CallToAction 
        title="Dijital Dönüşüm Yolculuğunuzda Yanınızdayız"
        subtitle="Projenizi konuşalım, birlikte en doğru çözümü üretelim."
        buttonText="Bize Ulaşın" 
        buttonLink="/iletisim" 
      />
    </div>
  );
};

export default About;
